import type { ApiDispatcher } from '@app/packages/internalApi/ApiDispatcher'

import { createThunk } from '@app/store/thunk'

export const getInternalApiDispatcher = () =>
  createThunk((_dispatch, _getState, context) => {
    return context.getRootContext().lookupEnsure<ApiDispatcher>(InternalApiDispatcherSymbol)
  })

export const setInternalApiDispatcher = (dispatcher: ApiDispatcher) =>
  createThunk((_dispatch, _getState, context) => {
    context.getRootContext().set(InternalApiDispatcherSymbol, dispatcher)
  })

const InternalApiDispatcherSymbol = Symbol('internalApiDispatcher')
